import { render, staticRenderFns } from "./NewsCom.vue?vue&type=template&id=d3967490&scoped=true"
import script from "./NewsCom.vue?vue&type=script&lang=js"
export * from "./NewsCom.vue?vue&type=script&lang=js"
import style0 from "./NewsCom.vue?vue&type=style&index=0&id=d3967490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3967490",
  null
  
)

export default component.exports